<template>
    <div class="select-server-groups">
        <div class="groups">
            <div v-for="group in groups" :key="group.sgid" class="form-group row mb-1">
                <label class="col-md-9 col-form-label" :for="group.sgid">
                    <server-group :group="group" :withName="true"/>
                </label>
                <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <b-form-checkbox
                        v-model="selected"
                        :value="group"
                        class="custom-checkbox-primary mb-3"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SelectServerGroups",
    props: {
        groups: Array,
        withName: Boolean,
        limit: Number,
        byHasProp: {
            Type: Boolean,
            Default: false
        }
    },
    data() {
        return {
            selected: [],
        }
    },
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        }
    },
    mounted() {
        this.groups.forEach(group => {
            if (!this.byHasProp && this.user.serverGroups.find(clientGroup => clientGroup.sgid == group.sgid))
                this.selected.push(group);

            if (this.byHasProp && group.has)
                this.selected.push(group);
        })
    },
    watch: {
        selected(newValue, oldValue) {
            let added = true;
            const elementChanged = newValue
                .filter(x => !oldValue.includes(x))
                .concat(oldValue.filter(x => {
                    if (!newValue.includes(x)) {
                        added = false;
                        return true;
                    } else
                        return false;
                }));


            if (this.selected.length > this.limit) {
                let toDelete = this.selected.length - this.limit;

                this.selected = this.selected.filter(x => {
                    if (toDelete > 0 && ((added && elementChanged !== x) || !added)) {
                        toDelete--;
                        return false;
                    }

                    return true;
                });
            }
        }
    },
    methods: {
        getSelected() {
            return this.selected;
        }
    }
}
</script>

<style>
    .server-group-icon {
        width: 24px;
        height: 24px;
        margin: 5px;
    }
</style>